// custom scripts
// dennis_@ rabbit hole



//Property of Rabbit Hole Distillery










//done






// WINDOW SCROLLED
$(window).scroll(function() {    
  var scroll = $(window).scrollTop();
  if (scroll >= 200) {
      $("body").addClass("scrolled");
  } else {
      $("body").removeClass("scrolled");
  }
  if (scroll >= 20) {
      $("body").addClass("first-scrolled");
  } else {
      $("body").removeClass("first-scrolled");
  }

  if (scroll >= 2000) {
     $('.promobox').removeClass('loaded');
  }

  
});



$(document).ready(function() {

  //console.log( "ready!" );
  $('body').addClass('ready');

  setTimeout(function(){
    $('body').addClass('ready1');
  }, 500);
  setTimeout(function(){
    $('body').addClass('ready2');
  }, 1000);
  setTimeout(function(){
    $('body').addClass('ready3');

    $('.promobox').addClass('loaded');
  }, 50);



  // Click function
  $('.menu-toggle').click(function(){
    $('body').toggleClass('menu-active');
    $('.ziz-pullout-overlay').toggleClass('menu-active');
    $('.ziz-pullout').toggleClass('active');
  });

  $('.mobile-menu-item-arrow').click(function () { 
      $(this).next('.sub-menu-list').toggleClass('menu-active');
      $(this).toggleClass('active');
  });

  // this opens the submenu when the page is loaded and there is an option selected - on mobile
  $('.site-mobile-nav--active.sub-link').parent().toggleClass('menu-active');
  $('.site-mobile-nav--active.sub-link').parent().prev('.mobile-menu-item-arrow').toggleClass('active');
  //

  var image = document.getElementsByClassName('parallax-img');
  new simpleParallax(image, {
    maxTransition: 600,
    scale: 1.2,
    overflow: true
  });






  // $('#age-yes').click(function() {
  //   $('.age-consent').addClass('yes-active');
  //   setTimeout(function(){
  //     $('.site-overlay-age').addClass('hide-now');
  //     $('body').removeClass('no-scroll-plz');
  //   }, 1000);

  //   console.log('age-yes');
  //   localStorage.setItem('popState','shown');

  // });
  // $('#age-no').click(function() {
  //   $('.age-consent').addClass('no-active');
  // });

  // if(localStorage.getItem('popState') == 'shown') {
  //   $('#age-gate').hide();
  // }
  // if(localStorage.getItem('popState') != 'shown') {
  //     $('#age-gate').delay(100).fadeIn();
  // }

	$('.js-autotab').on('keyup', function(){
  var self = this;
  
  var value = this.value;
  var max = $(this).attr('maxlength');
  
  if (value.length == max){
    
    var next = $('.js-autotab:eq(' + ($('.js-autotab').index(self) + 1) + ')');
    next.focus();
    
  }
  
}); 
  
  
  $('.birthdate-click').click(function(e) {
    e.preventDefault();
    $month = $('.month').val();
    $day = $('.day').val();
    $year = $('.year').val();
    if (ageValidation(21, $month, $day, $year)) {
      //alert('sorry not old enough');
      $('.age-consent').addClass('no-active');
    } else {
      //alert('old enough');
      $('.age-consent').addClass('yes-active');

      setTimeout(function(){
        $('.site-overlay-age').addClass('hide-now');
        $('body').removeClass('no-scroll-plz');
      }, 1000);

      localStorage.setItem('popState','shown');
    }

  });

  if(localStorage.getItem('popState') == 'shown') {
    $('#age-gate').hide();
  }
  if(localStorage.getItem('popState') != 'shown') {
      $('#age-gate').delay(100).fadeIn();
  }

  function ageValidation(age, birthMonth, birthDate, birthYear) {
    var a = age;
    var todaysDate = new Date();
    todaysDate.setFullYear(todaysDate.getFullYear() - a);
    var usersBirthDay = new Date();
    var bm = birthMonth;
    var bd = birthDate;
    var by = birthYear;
    usersBirthDay.setFullYear(by, bm - 1, bd);
    if ((todaysDate - usersBirthDay) < 0) {
      return true;
    } else return false
  }






  $('.main-nav-bourbon-rye').hover(function() {
    $('.ziz-dropdown-2020.whiskey-dropdown').addClass('active');
  }, function() {
    $('.ziz-dropdown-2020.whiskey-dropdown').removeClass('active');
  });

  $('.main-nav-media').hover(function() {
    $('.ziz-dropdown-2020.media-dropdown').addClass('active');
  }, function() {
    $('.ziz-dropdown-2020.media-dropdown').removeClass('active');
  });

  $('.main-nav-distillery-tours').hover(function() {
    $('.ziz-dropdown-2020.distillery-dropdown').addClass('active');
  }, function() {
    $('.ziz-dropdown-2020.distillery-dropdown').removeClass('active');
  });


  $('.main-nav-creative-partners').hover(function() {
    $('.ziz-dropdown-2020.creative-partners-dropdown').addClass('active');
  }, function() {
    $('.ziz-dropdown-2020.creative-partners-dropdown').removeClass('active');
  });

  $('.main-nav-other-spirits').hover(function() {
    $('.ziz-dropdown-2020.spirits-dropdown').addClass('active');
  }, function() {
    $('.ziz-dropdown-2020.spirits-dropdown').removeClass('active');
  });


  $('.main-nav-story').hover(function() {
    $('.ziz-dropdown-2020.story-dropdown').addClass('active');
  }, function() {
    $('.ziz-dropdown-2020.story-dropdown').removeClass('active');
  });

  $('.main-nav-virtual-tastings').hover(function() {
    $('.ziz-dropdown-2020.virtual-tastings-dropdown').addClass('active');
  }, function() {
    $('.ziz-dropdown-2020.virtual-tastings-dropdown').removeClass('active');
  });

  $('.main-nav-where-to-buy').hover(function() {
    $('.ziz-dropdown-2020.buy-online-dropdown').addClass('active');
  }, function() {
    $('.ziz-dropdown-2020.buy-online-dropdown').removeClass('active');
  });

  


  // main drop
  $('.ziz-dropdown-2020').hover(function() {
    $(this).addClass('active');
  }, function() {
    $(this).removeClass('active');
  });





  $('.faq-box h2').each(function() {
    var tis = $(this), state = false, answer = tis.next('div').slideUp();
    tis.click(function() {
      state = !state;
      answer.slideToggle(state);
      tis.toggleClass('active',state);
    });
  });




  // add to cart from grid mcs add to cart
  $(".mcs-open-cart").click(function() {
     $('#mcs-CartDrawer').toggleClass('active');
  });




  // add to cart from grid mcs add to cart
  $(".custom-select").click(function() {
     $(this).toggleClass('open');
  });






  


  // add to cart from grid mcs add to cart
  $(".quick-add-toggle").click(function() {
    $('.quick-add-options .only-item').trigger('click');

     $(this).toggleClass('active');
     $(this).parent().toggleClass('quick-shop-active');
  });
  $(".quick-shop-close").click(function() {
     $(this).parent().parent().removeClass('quick-shop-active');
  });




  $('.js-anchor-link').click(function(e){
    e.preventDefault();
    var target = $($(this).attr('href'));
    if(target.length){
      var scrollTo = target.offset().top;
      $('body, html').animate({scrollTop: scrollTo+'px'}, 800);
    }
  });






  
  // add visible to waypoints in viewport
  var viewport = $(window),
    setVisible = function (e) {
        var viewportTop = viewport.scrollTop() - 80, // add buffer to sotp area
            viewportBottom = viewport.scrollTop() + viewport.height() - 80 ;
        $('.waypoint').each(function () {
            var self = $(this),
                top = self.offset().top,
                bottom = top + self.height(),
                topOnScreen = top >= viewportTop && top <= viewportBottom,
                bottomOnScreen = bottom >= viewportTop && bottom <= viewportBottom,
                elemVisible = topOnScreen || bottomOnScreen;
            	self.toggleClass('visible', elemVisible);     
        });
    };
  viewport.scroll(setVisible);
  setVisible();


  // offset viewport
  $.fn.isOnScreen = function() {
    const win = $(window);
    
    const viewport = {
      top: win.scrollTop(),
      left: win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top - 600 + win.height();
      
    const bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();
      
    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
  };

  $(window).scroll(function() {
      // Iterate over elements with offset-scroll classes
      for (let i = 1; i <= 6; i++) {
          let element = $('.offset-scroll-' + i);
          
          // Check if the element exists on the page
          if (element.length > 0) {
              if (element.isOnScreen()) {
                  element.addClass('active');
              } else {
                  element.removeClass('active');
              }
          }
      }
  });

  // handle links with @href started with '#' only



  // liddel slider
  // var divisor = document.getElementById("divisor"),
  //     handle = document.getElementById("handle"),
  //     slider = document.getElementById("slider");

  // function moveDivisor() {
  //   handle.style.left = slider.value+"%";
  //   divisor.style.width = slider.value+"%";
  // }

  // window.onload = function() {
  //   moveDivisor();
  // };



  // SCROLL TO FUNCTION
  $(function() {
    $('[data-toggle="elementscroll"]').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - 120
          }, 1000);
          return false;
        }
      }
    });
  });




  // important scripts
  function loadScript(url, callback) {
      // Adding the script tag to the head as suggested before
      var head = document.getElementsByTagName('head')[0];
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      // Then bind the event to the callback function.
      // There are several events for cross browser compatibility.
      script.onreadystatechange = callback;
      script.onload = callback;
      // Fire the loading
      head.appendChild(script);
  }

  // DL - Comment - Script commented out as it returns 404 
  //loadScript("https://raw.githubusercontent.com/maxwellcarl/paymentscript/master/rabbithole.js");




  // video modal stuff
  var videoSrc;  
  $('.embed-video-play').click(function() {
      videoSrc = $(this).data( "src" );
      $('.vid-modal').addClass('active');
      $('.vid-overlay').addClass('active');
      setTimeout(function() { 
      $("#player").attr('src',videoSrc + "?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1" ); 
      }, 50);
  });

  $('.vid-modalclose').click(function() {
    $('.vid-modal').removeClass('active');
    $('.vid-overlay').removeClass('active');
    $("#player").attr('src',videoSrc); 
  });
  $('.vid-overlay').click(function() {
    $(this).prev().removeClass('active');
    $(this).removeClass('active');
    setTimeout(function() { 
    $("#player").attr('src',videoSrc); 
  }, 200);
  });









  $( "#zipcode_button" ).click(function() {

    var user_zipcode = $("#zipcode_input").val();
    var zipcode_array = [
      "40025",
       "40059",
       "40118",
       "40202",
       "40203",
       "40204",
       "40205",
       "40206",
       "40207",
       "40208",
       "40209",
       "40210",
       "40211",
       "40212",
       "40213",
       "40214",
       "40215",
       "40216",
       "40217",
       "40218",
       "40219",
       "40220",
       "40222",
       "40223",
       "40228",
       "40229",
       "40241",
       "40242",
       "40258",
       "40291",
       "40299",
       "47111",
       "47119",
       "47129",
       "47130",
       "47150",
       "47172" 
    ];
    
    if (zipcode_array.includes(user_zipcode) == true) {
      $(".validate-box").removeClass('validate-show');

      $("#zipcode_negative").addClass('validate-hidden');
      $("#zipcode_positive").addClass('validate-show');
    }
    else {
      $(".validate-box").removeClass('validate-show');

      $("#zipcode_positive").addClass('validate-hidden');
      $("#zipcode_negative").addClass('validate-show');
    }  
  });



  




}); // clode doc ready





//$(window).on('load', function() {
  
  $('.site-overlay').addClass('loaded');
  setTimeout(function(){
    //$('.site-overlay').addClass('loaded2');
  //}, 200);

    
    


    
    
    

  // 1st carousel, main
  $('.home-slider').flickity({
    groupCells: false,
    autoPlay: 6000,
    //wrapAround: true,
      contain: true,
    imagesLoaded: true,
      //freeScroll: true,
    prevNextButtons: true,
    wrapAround: true,
    freeScroll: false,
    //friction: 0.15,
    //selectedAttraction: 0.01,
    setGallerySize: true,
    resize: true,
    pageDots: true,
   arrowShape: { 
      x0: 30,
      x1: 60, y1: 50,
      x2: 65, y2: 50,
      x3: 35
    }
    
  });


    
    
    

   // product sliders
  $('.family-slider').flickity({
    cellAlign: 'left',
    groupCells: false,
    autoPlay: false,
    imagesLoaded: true,
    wrapAround: true,
    pageDots: true,
    arrowShape: { 
      x0: 30,
      x1: 60, y1: 50,
      x2: 65, y2: 50,
      x3: 35
    }
  });


  // product sliders
  $('.product-info-slider').flickity({
    cellAlign: 'left',
    groupCells: false,
    autoPlay: false,
    imagesLoaded: true,
    wrapAround: true,
    pageDots: true,
    arrowShape: { 
      x0: 30,
      x1: 60, y1: 50,
      x2: 65, y2: 50,
      x3: 35
    }
  });



  // 1st carousel, main
  $('.media-slider').flickity({
    cellAlign: 'left',
    groupCells: false,
    autoPlay: false,
    imagesLoaded: true,
    wrapAround: true,
    pageDots: false,
    arrowShape: { 
      x0: 25,
      x1: 60, y1: 45,
      x2: 65, y2: 40,
      x3: 35
    }
  });

  // 1st carousel, main
  $('.jbf-slider').flickity({
    autoPlay: false,
    imagesLoaded: true,
    wrapAround: true,
    pageDots: true,
    arrowShape: { 
      x0: 30,
      x1: 60, y1: 50,
      x2: 65, y2: 50,
      x3: 35
    }
  });

  // 1st carousel, main
  $('.events-slider').flickity({
    autoPlay: true,
    imagesLoaded: true,
    wrapAround: true,
    pageDots: false,
     arrowShape: { 
      x0: 30,
      x1: 60, y1: 50,
      x2: 65, y2: 50,
      x3: 35
    }
  });



  // 1st carousel, main
  $('.product-gallery-slider').flickity({
    autoPlay: 2500,
    pauseAutoPlayOnHover: false,
    wrapAround: true,
    imagesLoaded: true,
    pageDots: false,
     arrowShape: { 
      x0: 30,
      x1: 60, y1: 50,
      x2: 65, y2: 50,
      x3: 35
    }
  });

  // 1st carousel, main
  $('.cocktails-slider').flickity({
    autoPlay: 0,
    pauseAutoPlayOnHover: false,
    wrapAround: true,
    imagesLoaded: true,
    pageDots: false,
     arrowShape: { 
      x0: 30,
      x1: 60, y1: 50,
      x2: 65, y2: 50,
      x3: 35
    }
  });


    // 1st carousel, main
  $('.team-slider').flickity({
    autoPlay: 2500,
    pauseAutoPlayOnHover: false,
    cellAlign: 'left',
    wrapAround: true,
    imagesLoaded: true,
    pageDots: false,
     arrowShape: { 
      x0: 30,
      x1: 60, y1: 50,
      x2: 65, y2: 50,
      x3: 35
    }
  });


});